goog.provide("shadow.js.shim.module$$carbon$icons_react$es$inspection$16");
goog.provide("module$shadow_js_shim_module$$carbon$icons_react$es$inspection$16");
shadow.js.shim.module$$carbon$icons_react$es$inspection$16 = shadow.js.nativeProvides["@carbon/icons-react/es/inspection/16"] = shadow$bridge("@carbon/icons-react/es/inspection/16");
module$shadow_js_shim_module$$carbon$icons_react$es$inspection$16.default = shadow.js.shim.module$$carbon$icons_react$es$inspection$16;
